// dob-filter.js

document.getElementById('dob-months-filter-form').addEventListener('submit', function(e) {
  e.preventDefault();  // Prevent form from submitting immediately
  
  var childName = document.getElementById('child-name').value;  // Get the child's name
  var dob = document.getElementById('dob').value;  // Get the value from the date picker
  
  // Calculate the age in months
  var birthdate = new Date(dob);
  var today = new Date();
  var ageInMonths = (today.getFullYear() - birthdate.getFullYear()) * 12 + today.getMonth() - birthdate.getMonth();
  
  // If the birthday hasn't occurred yet this year, subtract 1 month
  if (today.getDate() < birthdate.getDate()) {
    ageInMonths--;
  }

  // Redirect to collection page with both child_name and age_in_months query parameters
  window.location.href = '/collections/all?child_name=' + encodeURIComponent(childName) + '&age_in_months=' + ageInMonths;
});
